<nz-spin class="parent-loader" [nzSpinning]="isSpinnerShow">
  <router-outlet></router-outlet>
</nz-spin>
